import { orpc } from "@/utils/orpc.client";

interface ArtistQueryOptionsInput {
  id: string;
  locale: string;
}

export function getArtistQueryOptions({ id, locale }: ArtistQueryOptionsInput) {
  return orpc.music.getArtist.queryOptions({
    input: { id, locale },
  });
}
